/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Ellipsis } from 'components/Ellipsis'

interface ResponsavelAtendimentoTextProps {
  showParticipante: boolean
  nomeProfissionalResponsavel: string
  nomeProfissionalParticipanteAgendamento?: string
}

export function ResponsavelAtendimentoText(props: ResponsavelAtendimentoTextProps) {
  const { showParticipante, nomeProfissionalResponsavel, nomeProfissionalParticipanteAgendamento } = props

  return (
    <div css={styles.profissionalResponsavelContainer}>
      <Ellipsis
        css={[
          styles.nomeProfissional,
          css`
            font-weight: bold;
          `,
        ]}
      >
        {nomeProfissionalResponsavel}
      </Ellipsis>
      {showParticipante && (
        <Ellipsis css={styles.nomeProfissional}>{`com ${nomeProfissionalParticipanteAgendamento}`}</Ellipsis>
      )}
    </div>
  )
}

const styles = {
  profissionalResponsavelContainer: css`
    display: grid;
  `,
  nomeProfissional: css`
    line-height: 1rem;
  `,
}
